// extracted by mini-css-extract-plugin
export default {"container":"styles_container__0fm22","text-container":"styles_text-container__ZH6f7"};